"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _TablePaginationActions = _interopRequireDefault(require("../../components/TablePaginationActions"));

var _CobaltIcon = _interopRequireDefault(require("../../components/CobaltIcon"));

var _Divider = _interopRequireDefault(require("@mui/material/Divider"));

var _material = require("@mui/material");

var TablePaginationTheme = function TablePaginationTheme(colors) {
  return {
    defaultProps: {
      ActionsComponent: _TablePaginationActions["default"],
      backIconButtonProps: {
        title: 'Page précédente'
      },
      component: 'div',
      nextIconButtonProps: {
        title: 'Page suivante'
      },
      labelRowsPerPage: 'Éléments par page :',
      labelDisplayedRows: function labelDisplayedRows(_ref) {
        var from = _ref.from,
            to = _ref.to,
            count = _ref.count;
        return /*#__PURE__*/_react["default"].createElement(_material.Grid, {
          container: true,
          spacing: 0,
          alignItems: "center",
          style: {
            margin: 0,
            padding: 0
          }
        }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
          item: true
        }, /*#__PURE__*/_react["default"].createElement(_Divider["default"], {
          sx: {
            marginRight: 3,
            height: '64px',
            background: colors.grey10
          },
          light: true,
          orientation: "vertical"
        })), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
          item: true
        }, "\xC9l\xE9ments ", from, " \xE0 ", to, " sur ", count));
      },
      SelectProps: {
        IconComponent: function IconComponent() {
          return /*#__PURE__*/_react["default"].createElement(_CobaltIcon["default"], {
            name: "chevron-down"
          });
        }
      },
      showFirstButton: true,
      showLastButton: true
    },
    styleOverrides: {
      root: {
        color: colors.ultramarine,
        lineHeight: '64px',
        padding: 0
      },
      toolbar: {
        padding: 0,
        height: 64
      },
      spacer: {
        flex: 'none'
      },
      actions: {
        flex: '1 1 auto',
        textAlign: 'right',
        marginRight: 24
      },
      selectIcon: {
        color: colors.ultramarine,
        fontSize: 16,
        top: 'calc(50% - 8px)'
      }
    }
  };
};

var _default = TablePaginationTheme;
exports["default"] = _default;